import React, { Component } from 'react';
import Piece from './Piece';
import {PIECE_TYPE, SQUARE_TYPE} from './Constans';
import "./Board.css"

export default class Square extends Component {

    render() {   
      const squareSize = this.props.squareSize;
      let classSquare = this.props.type === SQUARE_TYPE.BLACK ? 'square black-square' : 'square white-square';
      if (this.props.moveSquare && this.props.moveSquare === true) {
        classSquare += ' move-square';
      } else if (this.props.landingSquare && this.props.landingSquare === true) {
        classSquare += ' landing-square';
      } 
      if (this.props.selectedSquare) {
        classSquare += ' selected-square';
        
      }
      if (this.props.pickedSquare) {
        classSquare += ' picked-square';
      }

      let piece = '';
      if (this.props.piece) {
        piece = this.props.piece !== PIECE_TYPE.NONE ? <Piece type={this.props.piece}></Piece> : '';
      
      } 
      let bckgImg = "";
      if (this.props.editMode) {
        bckgImg = "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1'\
        height='50px' width='120px'>\
        <text x='0' y='8' fill='white' font-size='10'>"+(this.props.squareKey > 0 ? this.props.squareKey : '')+"</text></svg>\")"
      }
      let style = {
        width: squareSize, 
        height: squareSize, 
        minWidth: squareSize, 
        minHeight: squareSize,
        backgroundImage: bckgImg
      };

      return (
       <div className={classSquare} style={style}>
          {piece}
       </div>
       //<div className={classSquare} style={{width: squareSize, height: squareSize, minWidth: squareSize, minHeight: squareSize}}>
          //    {(((this.props.squareKey > 0 ? this.props.squareKey : 0) > 0) ? ""+ key + PIECE_SYMBOL[this.props.piece] : "")}</div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/board/Square.js